import { getHassObjectPorts } from '../../Hasp/properties/v2/hass/index.js';
import { hassDomain } from '../../hass/hassDomain.js';
import { pageHassObjects } from '../../hass/pageHass.js';
import GraphLayer from '../graph/GraphLayer.js';
import { hassRenderDomain } from './hassScene.js';

/**
 * Home Assistant flow as a layer domain: a UI object takes its Primary
 * Entity and bindings on a port at its left edge, and gives its events on a
 * port at its right edge.
 */
export const hassLayerDomain = Object.freeze({
    ...hassDomain,
    ...hassRenderDomain,
    sources: pageHassObjects,
    objectPorts: node => {
        const ports = getHassObjectPorts(node);
        return [
            ...ports.inputs.map(port => ({ id: port.id, dir: 'in', side: 'left', port })),
            ...ports.outputs.map(port => ({ id: port.id, dir: 'out', side: 'right', port })),
        ];
    },
});

/** Overlay layer for the active page's Home Assistant flow (see GraphLayer). */
export default class HassLayer extends GraphLayer {
    constructor({ objectLayer }) {
        super({ objectLayer, domain: hassLayerDomain });
    }
}
